import { render, staticRenderFns } from "./CProfilePanel.vue?vue&type=template&id=538572dd&"
import script from "./CProfilePanel.vue?vue&type=script&lang=js&"
export * from "./CProfilePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports